import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, effect, EventEmitter, HostListener
  , inject, input, OnDestroy, OnInit, Output, 
  ViewChild} from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { RouterOutlet } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ItmToolbarComponent } from '@itm/components/toolbar';
import * as atlas from "azure-maps-control";
import { takeUntil, tap } from 'rxjs/operators';
import { ActionAlertSubType, ActionType, IActions } from '../../../utilities';
import { environment } from "environments/environment";
import { MapComponent } from 'app/modules/admin/shared/maps.component';
import { TextAreaComponent, TextAreaModule } from '@syncfusion/ej2-angular-inputs';
import { CacNotifyService } from 'app/modules/admin/shared/services/cac.notify.service';
import { Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { ItmToastrService } from '@itm/services';
import moment from 'moment-timezone';
import { Utilities } from '@itm/constants/utilities';
import { GoogleMapEmbededComponent } from 'app/modules/admin/shared/google-map-embeded/google-map-embeded.component';
import { ItmBaseComponent } from '@itm/components/itm.base.component';

@Component({
    selector: 'alert-sidebar',
    templateUrl: './alert-sidebar.component.html',
    styleUrls: ['./alert-sidebar.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      // RouterOutlet, 
      CommonModule
      // , ItmToolbarComponent
      // , FuseAlertComponent
      , MatInputModule
      // , MapComponent
      , TextAreaModule, FormsModule, GoogleMapEmbededComponent],
    providers: [
    ],
})
export class AlertSidebarComponent extends ItmBaseComponent implements OnInit, OnDestroy  {

  additionalHeight: number = 70;
  containerHeight: any = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerWidth = event.target.innerWidth;
    const innerHeight = event.target.innerHeight;
    this.containerHeight = innerHeight - this.additionalHeight;

    const parentDiv = document.getElementById('innerContainer');
    if (parentDiv) {
      (parentDiv as HTMLElement).style.height = this.containerHeight + 'px';
    }
  }

  keyS0: string = environment["AZURE_MAPS_KEY_S0"];
  keyS1: string = environment["AZURE_MAPS_KEY_S1"];
  mapStyle: any = "road";

  @ViewChild('reason') reason!: TextAreaComponent;
  @Output() fireReminderHourEvent = new EventEmitter<any>();
  @Output() fireDoNotEscalateEvent = new EventEmitter<any>();
  @Output() fireResolveEvent = new EventEmitter<any>();

  actionData = input<IActions>();
  actionButton = computed(() => {
    return this.actionData()?.actionButton;
  });

  private readonly _cacNotifyService = inject(CacNotifyService);

  public map: atlas.Map;

  showReasonSec: boolean = false;
  ActionType = ActionType;
  ActionAlertSubType = ActionAlertSubType;

  postData: any =  {
    reason: ''
  };

  constructor() {
    super();
    effect(() => {
      // this.showReason = false;
      // this._changeDetectorRef.detectChanges();
      // console.log(this.actionData())
    })
  }

  ngOnInit(): void {
    this.setInnerContainerHeight();
    
    this._cacNotifyService.sidebarOpenedStatus$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(x => {
      this.showReasonSec = false;
      this._changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
  }

  onRemindHourClick(e: any){
    this.fireReminderHourEvent.emit({target: e});
  }

  onDoNotEscalateClick(e: any){
    this.reasonPlaceholder = 'Please add the reason.';
    if(this.showReasonSec == false){
      this.showReasonSec = true;
      this.postData.reason = '';
    }
    else {
      if(!this.postData.reason){
        this._toastr.showInfo(`Reason can't empty.`)
        this.reason?.focusIn();
        return;
      }
      this.fireDoNotEscalateEvent.emit({target: e, data: this.postData });
    }
  }
  
  // reasonPlaceholder: string = 'Please advise the reason for manually resolving this issue.';
  // onResolveClick(e: any){
  //   if(this.showReasonSec == false){
  //     this.showReasonSec = true;
  //     this.postData.reason = '';
  //   }
  //   else {
  //     if(!this.postData.reason){
  //       this._toastr.showInfo(`Reason can't empty.`)
  //       this.reason?.focusIn();
  //       return;
  //     }
  //     this.fireResolveEvent.emit({target: e, data: this.postData });
  //   }
  // }

  reasonPlaceholder: string = 'Please advise the reason for manually resolving this issue.';
  onResolveClick(e: any){
    if(this.actionButton()?.disabledResolve == true) return;
    
    if(this.showReasonSec == false){
      this.showReasonSec = true;
      this.postData.reason = '';
    }
    else {
      if(!this.postData.reason){
        this._toastr.showInfo(`Reason can't empty.`)
        this.reason?.focusIn();
        return;
      }
      this.fireResolveEvent.emit({target: e, data: this.postData });
    }
  }

  setInnerContainerHeight(){
    const innerHeight = window.innerHeight;
    this.containerHeight = innerHeight - this.additionalHeight;

    const parentDiv = document.getElementById('innerContainer');
    if (parentDiv) {
      (parentDiv as HTMLElement).style.height = this.containerHeight + 'px';
    }
  }
}
